import {makeAutoObservable} from "mobx";

export default class BibliothequeImageStore {
    constructor() {
        makeAutoObservable(this);
    }

    openModuleImage = false;
    openAddPhoto = false;
    openCamera = false;
    openUploadImage = false;
    openUploadQrCode = false;
    selectedImageModule = null;

    handleResetViews(){
        this.openModuleImage = false;
        this.openAddPhoto = false;
        this.openCamera = false;
        this.openUploadImage = false;
        this.openUploadQrCode = false;
    }

    handleOpenModuleImage(){
        this.openModuleImage = true;
    }

    handleCloseModuleImage(){
        this.openModuleImage = false;
        this.onResetImageModule();
    }

    handleOpenCamera(){
        this.openCamera = true;
        this.openAddPhoto = false;
    }

    handleCloseCamera(){
        this.openCamera = false
    }

    handleOpenAddPhoto(){
        this.openAddPhoto = true;
    }

    handleCloseAddPhoto(){
        this.openAddPhoto = false;
    }

    handleOpenUploadImage(){
        this.openUploadImage = true;
        this.openAddPhoto = false;
    }

    handleCloseUploadImage(){
        this.openUploadImage = false;
    }

    handleOpenUploadQrCode(){
        this.openUploadQrCode = true;
        this.openAddPhoto = false;
    }

    handleCloseUploadQrCode(){
        this.openUploadQrCode = false;
    }

    onSelectedImageModule = (image) => {
        this.selectedImageModule =   image;
    }

    onResetImageModule = () => {
        this.selectedImageModule = null;
    }


}